import { Col, Row } from "react-bootstrap"
import './Creditztype.css'

const Preview = ({ music, creditz, creditz2,furthurDetails, category }) => {

    return (
        <div
            className="card border-0 rounded-xl shadow-xs bg-primary"
            id="grad"
        >
            <div
                style={{
                    textAlign: "center",
                    marginTop: "10px",
                    paddingTop: "5px",
                }}
            >
                <h5 className="fs-20 fw-bold mb-0" style={{ color: "white" }}>
                    Preview               </h5>
            </div>
            <br></br>

            {
            category!== "Youtube Video"?(<Row style={{ marginTop: '20px' }}>
                <Col style={{ textAlign: 'center', paddingTop: '5px' }} md='6' sm='12'> <h5 style={{ color: "white", fontWeight: "bold", fontSize: 18 }}>Song Details</h5> </Col>
                <Col md='6' sm='12'></Col>
                <Col style={{ textAlign: 'center', paddingTop: '5px' }} md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>My Role</h5> </Col>
                <Col md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>{music.myrole}</h5> </Col>

                <Col style={{ textAlign: 'center', paddingTop: '5px' }} md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>Song Name</h5> </Col>
                <Col md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>{music.trackname}</h5> </Col>
                <Col style={{ textAlign: 'center', paddingTop: '5px' }} md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>Artist Name</h5> </Col>
                <Col md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>{music.artistname}</h5> </Col>


            </Row>):
            (
            <Row style={{ marginTop: '20px' }}>
            <Col style={{ textAlign: 'center', paddingTop: '5px' }} md='6' sm='12'> <h5 style={{ color: "white", fontWeight: "bold", fontSize: 18 }}>Video Details</h5> </Col>
            <Col md='6' sm='12'></Col>
            <Col style={{ textAlign: 'center', paddingTop: '5px' }} md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>My Role</h5> </Col>
            <Col md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>{music.myRole}</h5> </Col>

            <Col style={{ textAlign: 'center', paddingTop: '5px' }} md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>Video Name</h5> </Col>
            <Col md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>{music.videoName}</h5> </Col>
            <Col style={{ textAlign: 'center', paddingTop: '5px' }} md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>Video URL</h5> </Col>
            <Col md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>{music.videoURL}</h5> </Col>
            
            </Row>
            )
             
            }


            <Row style={{ marginTop: '20px' }}>
                <Col style={{ textAlign: 'center', paddingTop: '5px' }} md='6' sm='12'> <h5 style={{ color: "white", fontWeight: "bold", fontSize: 18 }}>Contributors</h5> </Col>
                <Col md='6' sm='12'></Col>
                {creditz?.map((credit) => {
                    return (
                    <Row>

                        <Col style={{ textAlign: 'center', paddingTop: '5px' }} md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>{credit.role}</h5> </Col>
                        <Col md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>{credit.selectedUsername.value}</h5> </Col>
                        </Row>
                        );

                })}

            </Row>

            <Row style={{ marginTop: '20px' }}>
                <Col style={{ textAlign: 'center', paddingTop: '5px' }} md='6' sm='12'> <h5 style={{ color: "white", fontWeight: "bold", fontSize: 18 }}>Furthur Details</h5> </Col>
                <Col md='6' sm='12'></Col>
                <Col style={{ textAlign: 'center', paddingTop: '5px' }} md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>Release Date</h5> </Col>
                <Col md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>{furthurDetails.releaseDate}</h5> </Col>

                <Col style={{ textAlign: 'center', paddingTop: '5px' }} md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>Copyright Owner</h5> </Col>
                <Col md='6' sm='12'> <h5 style={{ color: "white", fontWeight: 400, fontSize: 16 }}>{furthurDetails.Copyright}</h5> </Col>



            </Row>
        </div>
    )
}


export default Preview